import { Injectable } from '@angular/core';
import { ApiService } from '@core/http';
import { environment } from '@env';

@Injectable({
  providedIn: 'root',
})
export class AgoraApiProviderService {
  constructor(private apiService: ApiService) {}

  startSpeechToText(channelName: string, recordAudio: boolean) {
    return this.apiService.post(`${environment.environmentVariables.apiUrl}/api/transcription/start`, {
      channelName,
      recordAudio,
    });
  }

  stopSpeechToText(channelName: string, recordAudio: boolean) {
    return this.apiService.post(`${environment.environmentVariables.apiUrl}/api/transcription/stop`, {
      channelName,
      recordAudio,
    });
  }
}
